import Vue from 'vue';
import filters from './filter';
import globalData from '@kk-activity-factory/global-data';
import lazyload from '@kk/vue-lazy';
import tap from '@kk/tap';
import { compress, query, cookie, miniInit } from '@kk/utils';
import DialogController from '@kk/vue-dialog';
import Toast from '@kk/toast';
import saExpose from '@kk-activity-factory/sa-expose';
import {
    formatModuleId,
    globalInstance,
    enhanceRequest,
    kksaTrack,
} from '@kk-activity-factory/utils';
import { gsInterceptor } from '@kk-activity-factory/gs-interceptor';

// 首先要增强request
enhanceRequest();
// 使用防刷请求拦截器
request.interceptors.request.use(gsInterceptor);

tap(document.body);
Vue.use(lazyload);
Vue.use(saExpose);
Vue.prototype.$toast = Toast;

Vue.config.productionTip = false;

Vue.mixin({
    data: () => globalData,
    methods: {
        kksaTrack(event, param = {}) {
            return kksaTrack(event, param);
        },
        // 替换模块ID
        formatModuleId(moduleId) {
            return formatModuleId(moduleId, null);
        },
    },
    filters: {
        ...filters,
        compress,
    },
});

// eslint-disable-next-line sonarjs/cognitive-complexity
export async function init(store, App) {
    if (window.needShowToast) {
        window.loading.hide();
        Toast.show({
            text: window.needShowToast,
            time: 5000,
        });
        window.needShowToast = null;
        return;
    }
    try {
        if (globalData.isKuaikan) {
            const { sys: deviceInfo = {}, user = {} } = await window.getBaseInfoPromise;
            const deviceId = deviceInfo.device_id;
            const appVersion = deviceInfo.app_version;
            const appVersionName = deviceInfo.app_version_name;
            window.globalAppVersion = appVersion;
            window.globalAppVersionName = appVersionName;
            window.globalDeviceId = deviceId;
            store.commit(globalInstance.getMutationsKeys().SET_APP_VERSION, appVersion);
            console.info('appVersion', appVersion);
            Object.assign(request.defaults, {
                headers: {
                    'X-Device': deviceId,
                },
            });
            let userId = 0;
            // 如果用户登录
            if (user.status == 1) {
                store.commit(globalInstance.getMutationsKeys().LOGIN, user);
                userId = user.uid;
            }
            if (userId || deviceId) {
                kksa.identify(userId || deviceId);
            }
            // 设置sentry的id
            // eslint-disable-next-line sonarjs/no-collapsible-if
            if (process.env.VUE_APP_HOST_ENV !== 'development') {
                if (window.Sentry) {
                    window.Sentry.configureScope(function (scope) {
                        scope.setUser({ id: userId || deviceId });
                    });
                }
            }
        } else {
            // 端外上报至默认项目，不需要调用identify
            if (globalData.isKuaiKanMiniprogram) {
                const kkid = query.get('kkid');
                const session = query.get('session');
                const useragent = query.get('useragent');
                const kkidArr = kkid ? kkid.split('#') : [];
                const uid = session && kkidArr[1] ? kkidArr[1] : cookie.get('uid') || 0;
                const cookieDomian = process.env.VUE_APP_COOKIE_DOMAIN;
                if (session && uid) {
                    cookie.set('uid', uid, cookieDomian, '', '/');
                    cookie.set('passToken', session, cookieDomian, '', '/');
                    cookie.set('session', session, cookieDomian, '', '/');
                    store.commit(globalInstance.getMutationsKeys().LOGIN, {
                        uid: Number(uid),
                        status: 1,
                        session,
                    });
                } else {
                    cookie.remove('uid', cookieDomian);
                    cookie.remove('session', cookieDomian);
                    cookie.remove('passToken', cookieDomian);
                }
                Object.assign(request.defaults, {
                    headers: {
                        'User-Agent-Mini': useragent,
                        'mini-id': kkidArr[0],
                    },
                });
                kksa.identify(uid || kkidArr[0]);
                const rootVue = initVue(store, App);
                miniInit(() => (window.isJsSDKReady = true));
                return rootVue;
            }
        }
    } catch (error) {
        console.error('error in main', error);
        Toast.show({
            text: '页面加载出错，请退出重试～',
            time: 5000,
        });
    }
    return initVue(store, App);
}

function initVue(store, App) {
    Vue.config.errorHandler = function (err) {
        window.Sentry && window.Sentry.captureException(err);
        throw new Error(err.message);
    };
    return new Vue({
        store,
        render: (h) => h(App),
        created() {
            DialogController.bind(this); // 绑定根组件为所有弹窗组件的父节点
        },
    }).$mount('#app');
}
